import "./locationPrimaryContactDetailsViewComponent.scss";
import ButtonComponent from "../../../../../shared/components/core/button/ButtonComponent";
import EditIcon from "@mui/icons-material/Edit";
import {Grid} from "@mui/material";
import DetailsDataKeyValueComponent
    from "../../../../../shared/components/details-data-key-value-component/detailsDataKeyValueComponent";
import React from "react";
import {CommonService} from "../../../../../shared/services";
import commonService from "../../../../../shared/services/common.service";

interface LocationContactDetailsViewComponentProps {
    locationPrimaryContactDetails: any;
    onEditModeOpen: Function;
    canEdit: boolean;
}

const LocationPrimaryContactDetailsViewComponent = (props: LocationContactDetailsViewComponentProps) => {
    const {locationPrimaryContactDetails, onEditModeOpen, canEdit} = props;

    return (
        <div className={'primary-contact-details-view-component details-tab-data-content'}>
            <>
                <div className="details-tab-data-header">
                    <div className="view-and-edit-title">Primary Contact Details</div>
                    {
                        canEdit && <div className={'edit-action-button'}>
                            <ButtonComponent
                                className={"white-space-nowrap"}
                                type="button"
                                color={"primary"}
                                variant={"outlined"}
                                startIcon={<EditIcon/>}
                                fullWidth={true}
                                handleClick={onEditModeOpen}
                            >
                                Edit Details
                            </ButtonComponent>
                        </div>
                    }
                </div>
                <div className="details-tab-data-body">
                    <Grid container spacing={2} className="pdd-top-0">
                        <Grid item xs={12} sm={12} md={6} xl={6}>
                            <DetailsDataKeyValueComponent
                                title={"First Name"}> {locationPrimaryContactDetails?.firstName ? CommonService.capitalizeFirstLetterOfEachWord(locationPrimaryContactDetails?.firstName) : 'NA'} </DetailsDataKeyValueComponent>
                            <DetailsDataKeyValueComponent
                                title={"Last Name"}> {locationPrimaryContactDetails?.lastName ? CommonService.capitalizeFirstLetterOfEachWord(locationPrimaryContactDetails?.lastName) : 'NA'} </DetailsDataKeyValueComponent>
                            <DetailsDataKeyValueComponent
                                title={"Mobile Number"}> {commonService.getMaskedMobileNumber(locationPrimaryContactDetails?.mobileNumber) || 'NA'} </DetailsDataKeyValueComponent>
                            <DetailsDataKeyValueComponent
                                title={"Fax Number"}> {locationPrimaryContactDetails?.faxNumber ? commonService.getMaskedMobileNumber(locationPrimaryContactDetails?.faxNumber) : 'NA'} </DetailsDataKeyValueComponent>
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} xl={6}>
                            <DetailsDataKeyValueComponent
                                title={"Middle Name"}> {locationPrimaryContactDetails?.middleName ? CommonService.capitalizeFirstLetterOfEachWord(locationPrimaryContactDetails?.middleName) : 'NA'} </DetailsDataKeyValueComponent>
                            <DetailsDataKeyValueComponent
                                title={"Email ID"}> {locationPrimaryContactDetails?.emailId || 'NA'} </DetailsDataKeyValueComponent>
                            <DetailsDataKeyValueComponent
                                title={"Secondary Mobile Number"}> {CommonService.getMaskedMobileNumber(locationPrimaryContactDetails?.secondaryMobileNumber) || 'NA'} </DetailsDataKeyValueComponent>
                            <DetailsDataKeyValueComponent
                                title={"Account Executive"}> {locationPrimaryContactDetails?.accountExecutiveDetails?.firstName ? CommonService.capitalizeFirstLetterOfEachWord(locationPrimaryContactDetails?.accountExecutiveDetails?.firstName) + " " + CommonService.capitalizeFirstLetterOfEachWord(locationPrimaryContactDetails?.accountExecutiveDetails?.lastName) : 'N/A'} </DetailsDataKeyValueComponent>
                        </Grid>
                    </Grid>
                </div>
            </>
        </div>
    );

};

export default LocationPrimaryContactDetailsViewComponent;
